<template>
  <div>
    <v-dialog v-model="value" persistent max-width="60%">
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="header-title">
          Gửi tin nhắn
          <v-spacer></v-spacer>
          <v-icon @click="cancelAction()">close</v-icon>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="formValid" ref="myForm">
            <v-textarea class="mt-5" v-model="content" label="Tin nhắn" outlined></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendSMS">
            {{ $t('common.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <!--      <v-overlay :value="overlay" :z-index="0">-->
      <!--        <v-progress-circular indeterminate size="64"></v-progress-circular>-->
      <!--      </v-overlay>-->
    </v-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'send-sms-dialog',

  props: {
    value: Boolean,
    editedItem: Object,
  },


  data: () => ({
    e1: 1,
    date: '',
    modal: false,
    show: false,
    formValid: false,
    dialog: false,
    overlay: false,

    content: '',

    stringRules: [
      v => !!v || i18n.t('validate.string_require'),
      //   v => (v && v.length > 3) || i18n.t('validate.string_invalid')
    ],
    numberRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v > 0) || i18n.t('validate.string_invalid')
    ],
  }),

  computed: {

  },

  components: {

  },

  watch: {

  },

  async mounted() {

  },

  async created() {

  },

  methods: {
    async sendSMS() {
      this.$refs.myForm.validate();

      if (!this.validateInfor()) {
        return;
      }

      const requestBody = {
        message: this.content,
        user_id: this.editedItem.user.id
      }

      const response = await this.$pushNotification(requestBody);
      if (response.status === 200) {
        this.$emit('sendSuccess');
        this.$emit('closeDialog', false);
      } else {
        alert(i18n.t('validate.request_error'));
      }
    },

    validateInfor() {
      if (!this.content || this.content.length == 0) {
        return false;
      }

      return true;
    },

    cancelAction() {
      this.$emit('closeDialog', false);
    }
  }
}
</script>

<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
